import { useState, useEffect } from 'react';
import LoadingScreen from './components/LoadingScreen';
import Layout from './components/Layout';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BlogDetails from './components/BlogDetails';
import PrivacyPolicy from './sections/PrivacyPolicy';
import TermsConditions from './sections/TermsConditions';

const App = () => {
  const [theme, colorMode] = useMode();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading process, then hide the loader
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000); // Adjust the timeout as needed

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {loading ? (
          <LoadingScreen />
        ) : (
          <Router>
            <Routes>
              <Route path="/" element={<Layout />} />
              <Route path="/blog/:id" element={<BlogDetails />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
            </Routes>
          </Router>
        )}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
